import React, { useEffect, useMemo, useState } from "react";
import { DateRangePicker as RsuiteDateRangePicker } from "rsuite";
import { createPredefinedRanges } from "./predefinedRanges";
import "rsuite/dist/rsuite.min.css";
import "../../../Styles/components/date-range-picker.scss";

function getPickerPlacement(windowWidth) {
  if (windowWidth <= 991 && windowWidth >= 768) return "bottomEnd";
  if (windowWidth < 768) return "bottomStart";
  return "bottom";
}

export default function DateRangePicker({
  className = "",
  cleanable = true,
  disabled = false,
  allTimeStartDate,
  onChange,
  placeholder = "Select date range",
  value = null,
}) {
  const [windowWidth, setWindowWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isSmallScreen = windowWidth < 480;
  const placement = useMemo(() => getPickerPlacement(windowWidth), [windowWidth]);
  const ranges = useMemo(
    () => createPredefinedRanges(allTimeStartDate),
    [allTimeStartDate],
  );

  return (
    <div className={["date-range-picker", className].filter(Boolean).join(" ")}>
      <RsuiteDateRangePicker
        cleanable={cleanable}
        disabled={disabled}
        disabledDate={(date) => date > new Date()}
        editable={false}
        format="dd MMMM yyyy"
        onChange={onChange}
        placement={placement}
        placeholder={placeholder}
        ranges={isSmallScreen ? [] : ranges}
        showOneCalendar={isMobile}
        style={{ width: isMobile ? "100%" : 260 }}
        value={value}
      />
    </div>
  );
}
